<template>
  <b-container v-if="settings.display == 'map' && mapState == 1" fluid>
    <b-col>
      <groups-map :groups="groups" :template="mapTemplate"></groups-map>
    </b-col>
  </b-container>
  <b-container v-else-if="groupsWithElevators.length > 0" fluid>
    <b-row>
      <b-col sm="6" md="4" lg="2" v-for="group in groupsWithElevators" :key="group.id">
        <elevators-status-small :name="group.name" :groupId="group.id" :description="group.description"
          :elevators="group.elevators">
        </elevators-status-small>
      </b-col>
    </b-row>
  </b-container>
  <elevators v-else :elevators="elevators" :elevators-loaded="elevatorsLoaded"></elevators>
</template>

<script>
import api from './api.js'
import auth from './auth.js'
import moment from 'moment'
import axios from 'axios';
import formatter from './formatter.mixin.js';

import Elevators from './Elevators.vue'
import ElevatorsStatusSmall from './ElevatorsStatusSmall.vue'

import GroupsMap from './GroupsMap.vue'

export default {
  name: 'dashboard',
  mixins: [formatter],
  components: {
    'elevators': Elevators,
    'elevators-status-small': ElevatorsStatusSmall,
    'groups-map': GroupsMap,
  },
  props: [
    'settings',
    'elevators',
    'elevators-loaded',
    'groups'
  ],
  data() {
    return {
      mapTemplate: '',
      mapState: 0,
    }
  },
  computed: {
    groupsWithElevators: function () {
      if (this.groups) {
        return this.groups.filter(g => g.elevators.length > 0 && !g.hidden);
      }
    },
  },
  methods: {

  },
  mounted() {
  },
  created() {
    if (this.settings.display == 'map') {
      var ep = axios.create({
        baseURL: "",
      })

      ep.get('/static/img/map.svg')
        .then(res => {
          if (res.headers['content-type'] == 'image/svg+xml') {
            this.mapTemplate = res.data;
            this.mapState = 1;
          } else {
            this.mapState = -1;
          }
        })
        .catch(err => {
          this.mapState = -1;
        });
    }
  },
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/Dashboard.vue